export default __webpack_public_path__ + "static/media/Surfing2.05bb3d35.woff";